import Vue from 'vue'

Vue.filter('carNameDisplay', (name, brand) => {
  let value = ''
  if (brand) {
    value = value + '(' + brand + ') '
  }
  if (name) {
    value = value + name
  }
  return value
})

Vue.filter('comma', (value) => {
  if (value)
    return String(value).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  else
    return 0
})

Vue.filter('datetime', (value) => {
  // 22040912305000
  let datetime = '';
  if (value) {
    datetime += value.substr(0, 2);
    datetime += '-';
    datetime += value.substr(2, 2);
    datetime += '-';
    datetime += value.substr(4, 2);
    datetime += ' ';

    datetime += value.substr(6, 2);
    datetime += ':';
    datetime += value.substr(8, 2);
    datetime += ':';
    datetime += value.substr(10, 2);
    return datetime
  } else
    return 0
})

